/* eslint-disable jira/filename-case */
import { expValEquals } from '@atlassian/jira-feature-experiments';

/**
 * Relay provider that checks if the context panel fields reordering experiment is enabled.
 * Used to conditionally fetch fieldOperations.canEdit in field components.
 */
const issueViewContextPanelFieldsReorderingEnabled = {
	get(): boolean {
		return (
			expValEquals(
				'jira-work-item-reordering-fields-v2',
				'reorderingBehaviour',
				'withDragHandler',
				'noReordering',
			) ||
			expValEquals(
				'jira-work-item-reordering-fields-v2',
				'reorderingBehaviour',
				'withoutDragHandler',
				'noReordering',
			)
		);
	},
};

export default issueViewContextPanelFieldsReorderingEnabled;
